export const useFacebookPixel = () => {
  const trackEvent = (eventName: string, params?: object) => {
    if (window.fbq) {
      window.fbq('track', eventName, params)
      console.log(`Facebook Pixel: Tracked event "${eventName}"`, params)
    } else {
      console.warn('Facebook Pixel not initialized')
    }
  }
  return { trackEvent }
}
